export const SignableFormField = 'signable-form-field';

export enum SignableFieldType {
  Checkbox = 'checkbox',
  Company = 'company',
  DateSigned = 'date_signed',
  Email = 'email',
  Initials = 'initials',
  JobTitle = 'job_title',
  Name = 'name',
  Signature = 'signature',
  Text = 'text',
}

export interface DroppableSignableFormField {
  fontSize?: number;
  height: number;
  id?: string;
  name: string;
  pageNumber: number;
  scale?: number;
  signerId: string;
  signerIndex: number;
  type: SignableFieldType;
  width: number;
}

export const isSignatureField = (type: SignableFieldType) =>
  [SignableFieldType.Initials, SignableFieldType.Signature].includes(type);
